import React from 'react';
import { connect } from 'react-redux';
import List from '../../../../../../../components/common/List';
import Icon from '../../../../../../atoms/Icon';

class FacetL1CategoryList extends React.Component {
  render() {
    const {
      entities = {},
      facetsQuery,
      parentEntityId,
      setSeletedL1Category,
      seletedL1Category,
      l1Categories = {},
      luxe,
      isFleek,
      isFromFilter = false
    } = this.props;
    if (l1Categories.results && l1Categories.results.length > 0) {
      l1Categories.results.sort((entityIdA, entityIdB) => {
        const entityA = l1Categories.entities[entityIdA];
        const entityB = l1Categories.entities[entityIdB];
        if (entityA.count > entityB.count) {
          return -1;
        } else if (entityA.count < entityB.count) {
          return 1;
        }
        return 0;
      });
    }
    const parentEntity = entities[parentEntityId] || {};
    let { name = '', childrens = [], code } = parentEntity;
    let selectedFacets = this.props.selectedFacets;
    if (!selectedFacets) {
      selectedFacets = facetsQuery || {};
    }
    let selectedL1Categories = [];
    if (selectedFacets[code] && selectedFacets[code].length > 0) {
      selectedL1Categories = selectedFacets[code].reduce((acc, entityId) => {
        const entity = entities[`${code}-${entityId}`] || {};
        const { name = '' } = entity;
        const nameSplits = name.split('-');
        let l1Category;
        if (nameSplits[0]) {
          l1Category = nameSplits[0].trim().toLowerCase();
        }
        if (l1Category && !acc.includes(l1Category)) {
          acc.push(l1Category);
        }
        return acc;
      }, []);
    }

    return (
      <div style={luxe ? { paddingTop: '6px' } : {}}>
        <List
          numOfItems={l1Categories.results.length}
          listItemRenderer={listProps => {
            const { index } = listProps;
            const entityId = l1Categories.results[index];
            const entity = l1Categories.entities[entityId] || {};
            const { count = 0 } = entity;
            return (
              <div
                onClick={() => {
                  setSeletedL1Category(entityId);
                }}
              >
                <div
                  className={`facet-linkname ${
                    luxe ? 'facet-luxe-category-selection' : 'facet-category-selection'
                  }`}
                  role="button"
                  aria-label={`${entityId}, ${count} items`}
                  tabIndex={0}
                >
                  {!luxe ? (
                    selectedL1Categories.includes(entityId) ? (
                      <span
                        className={`ic-selected-facet ${isFleek ? 'fleek-ic-selected-facet' : ''}`}
                      />
                    ) : (
                      <span
                        className={`ic-unselected-facet ${
                          isFleek ? 'fleek-ic-unselected-facet' : ''
                        }`}
                      />
                    )
                  ) : (
                    ''
                  )}
                  {/* Label + Count */}
                  <span
                    className={`${
                      luxe ? 'rilrtl-list-luxe-item__title' : 'rilrtl-list-item__title'
                    } list-active`}
                    style={isFleek ? { color: '#FFF' } : {}}
                    // aria-label={`${entityId}`}
                    // role='button'
                  >
                    <strong>{`${entityId}`}</strong>&nbsp;
                    <span className="facet-item-count" style={isFleek ? { color: '#FFF' } : {}}>
                      {`(${count} items)`}
                    </span>
                  </span>
                  <span className="rilrtl-list-item__expand-detail" aria-hidden="true">
                    {luxe ? (
                      <Icon
                        icon="luxe-Go-Front"
                        styles={{ fontSize: '1.6rem' }}
                        ariaLabel="expand"
                      />
                    ) : (
                      <Icon
                        icon="icon-Chevron-Right"
                        styles={{
                          fontSize: '1.4rem',
                          color: isFleek ? '#EBFF00' : '#202020',
                          fontWeight: 'bold'
                        }}
                        ariaLabel="expand"
                      />
                    )}
                  </span>
                </div>
              </div>
            );
          }}
          isFleek={isFleek}
          isFromFilter={isFromFilter}
          // oldFlow
        />
        <div className="rilrtl-toolbar-bottom-fixed-adjust rilrtl-toolbar-bottom-fixed-adjust--filter-by" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { facets = {} } = state;
  const { nextFacets = {} } = facets || {};
  const { entities = {}, query: facetsQuery } = nextFacets;
  return { entities, facetsQuery };
}

export default connect(mapStateToProps)(FacetL1CategoryList);
